export const calendarMonth_December = "engBSe";
export default {calendarMonth_December};